<template lang="pug">
    DropDown.hzTreeSelectContainer.vm(ref="dropdown", @show="showHandler", :disabled="disabled", :dropBodyStyle="{display: 'flex', 'flex-direction': 'column'}")
        template(slot="dropHead")
            .pr
                select.hzFormElement(ref="hzFormElement", :name="name", tabindex="-1", :multiple="multiple")
                    option(selected, v-for="id in selectedIds", :value="id", :disabled="disabled")
                .hzIptResult(tabindex="0", ref="ipt", :disabled="disabled")
                    font(v-if="!selectedNodes.length", style="color: #ccc; line-height: 24px; margin-left: 7px") 请选择...
                    span(v-else, v-for="node in selectedNodes", :title="node[nodeKey]")
                        | {{node[defaultProps.label]}}
                        i(@click.stop.prevent="remove(node[nodeKey])", v-if="!disabled") ×
                    
        template(slot="dropBody")
            div.p10
                tree(ref="tree", :data="data", filter, :expandAll="true", @node-click="handleNodeClick", 
                    :nodeKey="nodeKey", :setRootSelect="false", :defaultProps="defaultProps", :multiple="multiple")
</template>

<script>
    import DropDown from './dropdown';
    import Tree from './tree'
    export default {
        name: 'hz-treeselect',
        components: { DropDown, Tree},
        props: {
            value: null, //选中的值, id数组或者id1,id2的形似
            disabled: { type: Boolean, default: false},
            data: { type: Object, default: null },
            multiple: { type: Boolean, default: false }, //是否允许多选
            // isOnlySelectedLast: { type: Boolean, default: false }, //是否限制只允许选中最后一级
            nodeKey          : { type: String, default: 'id' },
            defaultProps     : { type: Object, default: function(){ return {children: 'children', label: 'name', isLeaf: 'isLeaf', icon: 'icon'}}}
        },
        
        data() {
            return { 
            //    selectedNodes: []
            }
        },
        watch: {
            // value: {
            //     handler(val){
            //         if(Object.prototype.toString.call(val) == '[object Array]'){
            //             this.selectedNodes = this.dataArray.filter( item => val.indexOf(item[this.nodeKey]) > -1);
            //         }else{
            //             const obj = this.dataArray.find(item => item[this.nodeKey] == val);
            //             this.selectedNodes = obj ? [obj] : []
            //         }
            //     },
            //     immediate: true
            // }
        },
        computed: {
            dataArray(){
                if(!this.data || $.isEmptyObject(this.data)) return [];
                return hz.tools.obj.treeObjToArray(this.data)
            },
            selectedNodes(){
                if(Object.prototype.toString.call(this.value) == '[object Array]'){
                    return this.dataArray.filter( item => this.value.indexOf(item[this.nodeKey]) > -1);
                }else{
                    const obj = this.dataArray.find(item => item[this.nodeKey] == this.value);
                    return obj ? [obj] : []
                }
            },
            selectedIds(){
                return this.selectedNodes.map(item => item[this.nodeKey])
            }
        },
        
        methods: {
            showHandler(){
                this.$refs.tree && this.$refs.tree.setCurrentKeyTree(this.value)
            },
            handleNodeClick(node){
              const obj = this.selectedNodes.find(item => item[this.nodeKey] == node[this.nodeKey]);
              if(!obj){
                  if(!this.multiple){
                        // this.selectedNodes = [node];
                        this.$refs.dropdown.hide();
                        this.$emit("input", node[this.nodeKey])
                  }else{
                        const ids = this.selectedNodes.map(item => item[this.nodeKey])
                        ids.push(node[this.nodeKey]);
                        this.$emit("input", ids)
                  }
              }else{
                    this.remove(node[this.nodeKey])
              }
            },
            remove(id){
                this.$refs.tree && this.$refs.tree.cancelCurrentKey(id)
                if(!this.multiple){
                    // this.selectedNodes = [];
                    this.$emit("input", '')
                }else{
                    // this.selectedNodes = this.selectedNodes.filter(item => item[this.nodeKey] != id);
                    const ids = [];
                    this.selectedNodes.map(item => {
                        if(item[this.nodeKey] != id){
                            ids.push(item[this.nodeKey])
                        }
                    })
                    this.$emit("input", ids)
                }
            }
        }
    }
</script>

<style lang="stylus">
    .hzTreeSelectContainer
        vertical-align middle
        .hzFormElement
            opacity 0
            position absolute
            left 0
            width 0
            top 0
            bottom 0
            height 100%
            width 100%
            z-index -1
        .hzIptResult
            padding 3px
</style>
            



// WEBPACK FOOTER //
// src/treeSelect.vue